import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import packageJson from "../../../package.json";
import ModalHeader from "./ModalHeader";
import styled from "styled-components";

const Content = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: #000;
  color: white;
`;

const AboutDevice = ({ isOpen, onClose }) => (
  <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
    <ModalHeader title="About Device" onClose={onClose} />
    <Content>
      <Typography variant="h6" align="center" sx={{ fontWeight: 600 }}>
        Movu
      </Typography>
      <Typography variant="body2" align="center" sx={{ marginTop: 1 }}>
        Version: {packageJson.version}
      </Typography>
      <Typography variant="body2" align="center" sx={{ color: "#A0A0A0" }}>
        Powered by Nexus MD
      </Typography>
    </Content>
  </Dialog>
);

export default AboutDevice;
